import { colors } from '../../colors';
var accordion = {
  bodyBackgroundColor: colors.whiteish,
  iconColor: colors.rust,
  rowBackgroundColor: colors.overcast,
  textColorDark: colors.graphite,
  textColorLight: colors.white
};
export default accordion;